module.exports = __webpack_public_path__ + "img/ico_circle_delete_color.910ec386.svg";